module.exports = require('./helpers/bundle-url').getBundleURL('e4Pni') + "logo-dark.eefe0b7f.svg";